(async () => {
    const { 
        loadScript,
        loadStyle
    } = await import(window.theme.modules.utils);

    const baseComponent = await import(window.theme.modules.baseComponent);

    customElements.define('video-player', class extends baseComponent.default {
        elements = {
            player: '[data-player]',
            HTMLPlayer: 'video'
        }

        render() {
            if (this.hasAttribute('internal')) return;
            const button = this.querySelector('[data-video-activate]');
            button?.addEventListener('click', () => {
                const frame = this.querySelector('[data-video-template]')?.content.querySelector('iframe')?.cloneNode(true);
                if (!frame) return;
                const url = new URL(frame.src, location.href);
                url.searchParams.set('autoplay', '1');
                url.searchParams.set('controls', '1');
                if (url.hostname.endsWith('youtube.com')) url.searchParams.set('origin', location.origin);
                frame.src = url.href;
                frame.title = button.getAttribute('aria-label');
                frame.allow = 'autoplay; fullscreen; picture-in-picture';
                frame.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;border:0';
                this.$player.replaceChildren(frame);
            }, { once: true });
        }

        async onIntersect(isIntersecting) {
            if (!this.hasAttribute('internal')) return;
            if(isIntersecting && !this.player) {
                await this._initPlayer();
            }
            if(!isIntersecting && this.player && this.player.playing) {
                this.player.pause();
            }
        }

        async _initPlayer() {
            loadStyle('https://cdn.plyr.io/3.6.8/plyr.css');
            if(!window.Plyr) {
                await loadScript(window.theme.scripts.Plyr);
            }
            this.player = new window.Plyr(this.hasAttribute('internal') ? this.$HTMLPlayer : this.$player);
        }
    })
})();